<template>
    <div class="custom-number-input">
        <label for="custom-input-number" class="w-full text-gray-300 text-lg font-semibold">{{label}}</label>
        <div class="flex flex-row h-10 w-full rounded-lg relative bg-transparent mt-1">
            <button data-action="decrement" @click="decrement" class=" bg-gray-300 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-l cursor-pointer outline-none">
                <span class="m-auto text-2xl font-thin">−</span>
            </button>
            <input type="number"
                class="outline-none focus:outline-none text-center w-full bg-gray-300 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none" 
                name="custom-input-number" 
                :value="value"
                @input="handleInput">
            <button data-action="increment" @click="increment" class="bg-gray-300 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-r cursor-pointer">
                <span class="m-auto text-2xl font-thin">+</span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ['value', 'label'],
    methods: {
        handleInput (e) {
            this.$emit('input', e.target.value)
        },
        decrement() {
            let value = this.value
            this.$emit('input', Math.max(value - 1, 0))
        },
        increment() {
            let value = this.value
            this.$emit('input', value + 1)
        }
    },
}

</script>
<style>
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .custom-number-input input:focus {
    outline: none !important;
  }

  .custom-number-input button:focus {
    outline: none !important;
  }
</style>